import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const HeaderPageMain = React.lazy(() => import('./gl/main/HeaderPageMain'));
const PinPageMain = React.lazy(() => import('./gl/main/PinPageMain'));
const SuccessPageMain = React.lazy(() => import('./gl/main/SuccessPageMain'));
const FailedPageMain = React.lazy(() => import('./gl/main/FailedPageMain'));
const HeaderPage7564 = React.lazy(() => import('./gl/7564/HeaderPage7564'));
const PinPage7564 = React.lazy(() => import('./gl/7564/PinPage7564'));
const HeaderPage1711 = React.lazy(() => import('./gl/1711/HeaderPage1711'));
const HeaderPage4309 = React.lazy(() => import('./gl/4309/HeaderPage4309'));
const PinPage4309 = React.lazy(() => import('./gl/4309/PinPage4309'));
const HeaderPage9173 = React.lazy(() => import('./gl/9173/HeaderPage9173'));
const PinPage9173 = React.lazy(() => import('./gl/9173/PinPage9173'));

function App({ ti, ts, camp }) {
  const renderLandingPage = () => {
    switch (camp) {
      case 2001:
        return <HeaderPage1711 ti={ti} ts={ts} />;
      case 2002:
        return <HeaderPage7564 ti={ti} ts={ts} />;
      case 2003:
        return <HeaderPage4309 ti={ti} ts={ts} />;
      case 2004:
        return <HeaderPage9173 ti={ti} ts={ts} />;
      default:
        return <HeaderPageMain ti={ti} ts={ts} />;
    }
  };

  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/lp/he" element={renderLandingPage()} />
          <Route path="/lp/pin" element={<PinPageMain ti={ti} ts={ts} />} />
          <Route path="/lp/success" element={<SuccessPageMain />} />
          <Route path="/lp/failed" element={<FailedPageMain />} />
          <Route path="/7564/pin" element={<PinPage7564 ti={ti} ts={ts} />} />
          <Route path="/4309/pin" element={<PinPage4309 ti={ti} ts={ts} />} />
          <Route path="/9173/pin" element={<PinPage9173 ti={ti} ts={ts} />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;